import { DSFlex } from '@zoe/ds-web'
import Image from 'next/image'
import React, { useContext } from 'react'

import type { FragmentComponent } from '@/types/graphql'

import { TrackingContext } from '@/context/trackingContext'

import { trackCtaClick } from '@/lib/gtm/gtmV2'

export type AppDownloadCtaRecord = {
  __typename: 'AppDownloadCtaRecord'
  id: string
  showAppStore?: boolean
  showGooglePlay?: boolean
  appStoreUrl?: string
  googlePlayUrl?: string
  dataTestId?: string
}

const fragment = `
  fragment AppDownloadCtaFragment on AppDownloadCtaRecord {
    __typename
    id
    showAppStore
    appStoreUrl
    showGooglePlay
    googlePlayUrl
    dataTestId
  }
`

export const AppDownloadCta: FragmentComponent<{}, AppDownloadCtaRecord> = ({ record }) => {
  const { section } = useContext(TrackingContext)
  return (
    <DSFlex direction="row" gap={16} alignItems="center" testId={record.dataTestId}>
      {record.showAppStore && (
        <a
          href={record.appStoreUrl || 'https://apps.apple.com/us/app/zoe-insights/id1471632228'}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCtaClick(section || 'cms', 'App Store Download')}
        >
          <Image src="/assets/img/app/AppStore.png" alt="Download on the App Store" width={166} height={50} />
        </a>
      )}
      {record.showGooglePlay && (
        <a
          href={record.googlePlayUrl || 'https://play.google.com/store/apps/details?id=com.joinzoe.results'}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCtaClick(section || 'cms', 'Google Play Download')}
        >
          <Image src="/assets/img/app/PlayStore.png" alt="Get it on Google Play" width={166} height={50} />
        </a>
      )}
    </DSFlex>
  )
}

AppDownloadCta.fragment = fragment
AppDownloadCta.recordName = 'AppDownloadCtaRecord'
